// Per-slug scope hints. Drives the muted second line on each welcome
// row. Falls back to shortName + jurisdiction count when no hint is
// authored — keeps newly-added verticals from rendering blank.
export const SCOPE_HINTS: Record<string, string> = {
  cdl: "CDL · all states",
  oupv: "USCG · charter",
  "uscg-100t-master": "USCG · 100-ton master",
  "faa-part-107": "Drone pilot",
  "nmls-safe-mlo": "Mortgage originator",
  "epa-608": "HVAC refrigerant",
  "nasm-personal-trainer": "Personal trainer",
  "ptcb-pharmacy-tech": "Pharmacy tech",
  "mblex-massage": "Massage therapy",
  "real-estate": "Real estate salesperson",
  notary: "Notary public",
  "insurance-adjuster": "Insurance adjuster",
  "ctec-tax-preparer": "CA tax preparer",
};

interface MetaArgs {
  slug: string;
  shortName: string;
  stateCount: number;
}

// Resolve the muted "meta" line for a credential. Hand-authored hint
// wins; otherwise we compose "{Short} · {N} states" or "{Short} · federal".
export function resolveScopeHint({
  slug,
  shortName,
  stateCount,
}: MetaArgs): string {
  return (
    SCOPE_HINTS[slug] ??
    (stateCount > 0
      ? `${shortName} · ${stateCount} ${stateCount === 1 ? "state" : "states"}`
      : `${shortName} · federal`)
  );
}
